import { date, numeric, pgEnum, pgTable, unique } from 'drizzle-orm/pg-core'
import { countryEnum } from '../entities/country-enum'
import { id } from '../utils/columns'

// `reduced_2` is a second reduced rate: AT 13 %, CH 3.8 %. Germany has none.
export const vatRateClassEnum = pgEnum('vat_rate_class', ['standard', 'reduced', 'reduced_2', 'zero'])
export type VatRateClass = (typeof vatRateClassEnum.enumValues)[number]

/**
 * Global, developer-seeded VAT rates. Named `vat_rates` (plural) because the legacy `vat_rate`
 * Postgres enum already owns that type name, and every table also creates a type of its own name.
 *
 * `validFrom` is the first day a rate applies and `validTo` the last (inclusive); a null
 * `validTo` is open-ended. Dates are calendar days, so they stay strings.
 */
export const vatRates = pgTable(
  'vat_rates',
  {
    id,
    country: countryEnum('country').notNull(),
    class: vatRateClassEnum('class').notNull(),
    percent: numeric('percent', { precision: 5, scale: 2 }).notNull(),
    validFrom: date('valid_from', { mode: 'string' }).notNull(),
    validTo: date('valid_to', { mode: 'string' }),
  },
  (table) => [
    unique('uq_vat_rates_country_class_valid_from').on(
      table.country,
      table.class,
      table.validFrom,
    ),
  ],
)

export type VatRateRow = typeof vatRates.$inferSelect
export type VatRateRowInsert = typeof vatRates.$inferInsert
